<div class="row">
  <div class="col-4">
    <div class="card text-center">
      <div class="card-header billing-title-card-header">
        {{packageTitle}}
      </div>
      <div class="card-body billing-title-card-body">
        {{packageCostTitle}}
      </div>
      <div class="card-footer billing-title-card-footer">
        {{packageAdditionalCostTitle}}
      </div>
    </div>

  </div>
  <div class="col-8 card-group row">
  @for (billingPackage of billingPackages; track billingPackage) {
    <ibp-package-select-item class="col-4 px-1" [billingPackage]="billingPackage"></ibp-package-select-item>
  }
  </div>
</div>
